import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Typography, Button, Stack} from 'views/components';

import {Translate} from 'views/module';

const NavbarAccount = (props) => {
  const {
    account,
    setAccount,
  } = props;

  return (
    <Stack
      direction="row"
      sx={{
        width: '60%',
        minWidth: 0,
        my: 1,
        ml: 1,
      }}
      alignItems="center"
      justifyContent="space-evenly"
      spacing={1}
    >
      <Button
        variant='text'
        onClick={() => setAccount('care')}
        disableElevation
        disableRipple
        href='tasks/my-day'
        underline='none'
        sx={{
          'color': account === 'care' ? 'primary.main' : 'navbar.text',
          'minWidth': 'auto',
          'textTransform': 'none',
          'p': 0,
          '&:hover': {
            backgroundColor: 'transparent',
            color: 'primary.main',
          },
        }}
      >
        <Typography
          sx={{
            'textTransform': 'none',
            'fontSize': '.9rem',
          }}
        >
          <Translate expression='navbar.NavAccounts.Care.Title' />
        </Typography>
      </Button>
      <span>&bull;</span>
      <Button
        variant='text'
        onClick={() => setAccount('recruiter')}
        disableElevation
        disableRipple
        href='tasks/my-day'
        underline='none'
        sx={{
          'color': account === 'recruiter' ? 'primary.main' : 'navbar.text',
          'minWidth': 'auto',
          'textTransform': 'none',
          'p': 0,
          '&:hover': {
            backgroundColor: 'transparent',
            color: 'primary.main',
          },
        }}
      >
        <Typography
          sx={{
            'textTransform': 'none',
            'fontSize': '.9rem',
          }}
        >
          <Translate expression='navbar.NavAccounts.Recruiter.Title' />
        </Typography>
      </Button>
      <span>&bull;</span>
      <Button
        variant='text'
        onClick={() => setAccount('ops')}
        disableElevation
        disableRipple
        href='tasks/my-day'
        underline='none'
        sx={{
          'color': account === 'ops' ? 'primary.main' : 'navbar.text',
          'minWidth': 'auto',
          'textTransform': 'none',
          'p': 0,
          '&:hover': {
            backgroundColor: 'transparent',
            color: 'primary.main',
          },
        }}
      >
        <Typography
          sx={{
            'textTransform': 'none',
            'fontSize': '.9rem',
          }}
        >
          <Translate expression='navbar.NavAccounts.Ops.Title' />
        </Typography>
      </Button>
    </Stack>
  );
};

NavbarAccount.propTypes = {
  account: PropTypes.oneOf(['care', 'recruiter', 'ops']).isRequired,
  setAccount: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarAccount));
